import type {
    AnalyticsEstimateDto,
    AnalyticsExportDto,
    AnalyticsExportsPageDto,
    AnalyticsLinkDto,
} from './dto';
import type {
    AnalyticsDownloadLink,
    AnalyticsEstimate,
    AnalyticsExport,
    AnalyticsExportsPage,
} from './types';

export const parseRfc1123 = (value: string | null | undefined): string | null => {
    if (!value) {
        return null;
    }

    const timestamp = Date.parse(value);

    return Number.isNaN(timestamp) ? null : new Date(timestamp).toISOString();
};

export const mapAnalyticsExport = (dto: AnalyticsExportDto): AnalyticsExport => ({
    id: dto.id,
    since: dto.since,
    till: dto.till,
    status: dto.status,
    createdAt: parseRfc1123(dto.created_at),
    startedAt: parseRfc1123(dto.started_at),
    finishedAt: parseRfc1123(dto.finished_at),
    authorEmail: dto.author_email ?? '',
    authorName: dto.author_name ?? '',
    fileName: dto.file_name,
    fileSize: dto.file_size,
    rows: dto.rows,
    sheets: dto.sheets ?? 1,
    error: dto.error,
});

export const mapAnalyticsExportsPage = (dto: AnalyticsExportsPageDto): AnalyticsExportsPage => ({
    items: (dto.exports ?? []).map(mapAnalyticsExport),
    count: dto.count ?? 0,
    pages: dto.pages ?? 1,
    pageNum: dto.page_num ?? 1,
});

export const mapAnalyticsEstimate = (dto: AnalyticsEstimateDto): AnalyticsEstimate => ({
    positions: dto.positions,
    rows: dto.rows,
    maxRows: dto.max_rows,
    maxMonths: dto.max_months,
    tillMax: dto.till_max,
    allowed: dto.allowed,
    reason: dto.reason,
});

export const mapAnalyticsLink = (dto: AnalyticsLinkDto): AnalyticsDownloadLink => ({
    url: dto.url,
    fileName: dto.file_name,
    expiresIn: dto.expires_in,
});